import { injectable } from 'inversify';
import type { IReportRenderer, IReportRendererFactory } from './interfaces';

@injectable()
/**
 * Represents a factory for creating report renderers.
 * It's used to stub a real report renderer factory (for IOC) as the real one becomes available after surgery IOC container is created.
 */
export class RendererFactory implements IReportRendererFactory {
  public createReportRenderer(): IReportRenderer {
    return {
      renderReport: (): Promise<Blob> => {
        return Promise.resolve(new Blob());
      }
    };
  }
}
